import { useEffect, useState } from "react";
import useAdminNavigate from "@/hooks/useAdminNavigate";
import { notify } from "@/components/common/Notification";
import { DataOperationsService } from "@/services/APIs";
import navigationRoutes from "@/utils/navigationRoutes";

export const useImportState = () => {
  const navigate = useAdminNavigate();

  // Form state management
  const [selectedSchema, setSelectedSchema] = useState<string>("");
  const [selectedSchemaId, setSelectedSchemaId] = useState<string>("");
  const [importId, setImportId] = useState<string | null>(null);

  const [fileColumns, setFileColumns] = useState<string[]>([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [isUploading, setIsUploading] = useState(false);
  const [isUpdatingMapping, setIsUpdatingMapping] = useState(false);
  const [isRunningImport, setIsRunningImport] = useState(false);
  const [isMappingSaved, setIsMappingSaved] = useState(false);
  const [importType, setImportType] = useState<string>("create new records");

  const handleRunImport = async (importId: string) => {
    setIsRunningImport(true);
    const response = await DataOperationsService.runImport(importId);
    if (response) {
      setTimeout(() => {
        navigate(navigationRoutes.IMPORTS);
      }, 2000);
    }
    setIsRunningImport(false);
  };

  const handleRunImportClick = () => {
    if (!importId) {
      notify.error("No Import ID", "Please upload a file first.");
      return;
    }

    handleRunImport(importId);
  };

  // Reset form when component mounts
  useEffect(() => {
    setSelectedSchema("");
    setSelectedSchemaId("");
    setImportId(null);
    setFileColumns([]);
    setCurrentStep(1);
    setIsMappingSaved(false);
  }, []);

  return {
    // State
    selectedSchema,
    setSelectedSchema,
    selectedSchemaId,
    setSelectedSchemaId,
    importId,
    setImportId,
    fileColumns,
    setFileColumns,
    currentStep,
    setCurrentStep,
    isUploading,
    setIsUploading,
    isUpdatingMapping,
    setIsUpdatingMapping,
    isRunningImport,
    setIsRunningImport,
    isMappingSaved,
    setIsMappingSaved,
    importType,
    setImportType,
    // Actions
    handleRunImport,
    handleRunImportClick,
  };
};
